import ReactModal from 'react-modal';
import { modalStyle } from '../../../../../../../utils/modal';
import Button from 'react-bootstrap/Button';
import Col from 'react-bootstrap/Col';
import Row from 'react-bootstrap/Row';
import Form from 'react-bootstrap/Form';
import { Spinner } from '../../../../../../../components/Spinner';
import { useRef, useState } from 'react';
import { toast } from 'react-toastify';
import { useAuth } from '../../../../../../../hooks/useAuth';
import { useEnv } from '../../../../../../../context/env-context';
import { makeUploadRequest } from '../../../../../../../utils/makeRequest';

function RewardUploadFileModal({
  uploadFileModal,
  closeModal,
  rewardType,
  setReward,
  setUpdateIcon,
}) {
  const { apiOriginConsumer } = useEnv();
  const { getAccessTokenSilently } = useAuth();

  const fileInputRef = useRef(null);

  const [spinner, setSpinner] = useState(false);
  const [uploadedFile, setUploadedFile] = useState(null);

  const handleFileChange = e => {
    const file = e.target.files[0];

    fileInputRef.current.value = null;

    if (!file) return;

    if (uploadFileModal?.accept === '.html' && file.type !== 'text/html') {
      toast.error('Only .html files are allowed!');
    }

    setUploadedFile(file);
  };

  const close = () => {
    setUploadedFile(null);
    closeModal();
  };

  const handleUpdate = async () => {
    const token = await getAccessTokenSilently();

    if (!token) {
      return;
    }

    if (uploadFileModal?.type === 'file') {
      setSpinner(true);

      const data = new FormData();

      data.append('file', uploadedFile);
      data.append('fileName', uploadedFile.name);
      data.append('type', rewardType);

      try {
        await makeUploadRequest(`${apiOriginConsumer}/rewards/type/upload_file`, data, token);

        setReward(prev => ({
          ...prev,
          data: {
            ...prev.data,
            fileName: { ...prev.data.fileName, [uploadFileModal?.language]: uploadedFile.name },
          },
        }));
        close();
        toast.success('File uploaded successfully. To save the changes, press the SAVE button.');
      } catch (error) {
        toast.error(error.message);
      } finally {
        setSpinner(false);
      }
    }

    if (uploadFileModal?.type === 'icon') {
      setSpinner(true);

      try {
        const data = new FormData();

        data.append('file', uploadedFile);
        data.append('type', rewardType);
        data.append('iconSize', uploadFileModal?.iconSize);

        await makeUploadRequest(`${apiOriginConsumer}/rewards/type/upload_icon`, data, token);
        close();
        setUpdateIcon(prev => ({
          ...prev,
          [uploadFileModal?.iconSize === 256 ? 'large' : 'small']: true,
        }));
        toast.success('Icon uploaded successfully. It may take a minute to reflect changes.');
      } catch (error) {
        toast.error(error.message);
      } finally {
        setSpinner(false);
      }
    }
  };

  return (
    <ReactModal
      isOpen={!!uploadFileModal}
      style={modalStyle({ width: '460px' })}
      shouldCloseOnOverlayClick={!spinner}
      shouldCloseOnEsc={!spinner}
      onRequestClose={close}
    >
      <Spinner visible={spinner}>
        <h5>Upload File:</h5>
        <div className="mt-4">
          <Form.Label>Only {uploadFileModal?.accept} files are allowed</Form.Label>
          <Form.Control
            ref={fileInputRef}
            accept={uploadFileModal?.accept}
            className="bo-common-popover-form-menu-input w-100"
            type="file"
            onChange={handleFileChange}
          />
        </div>
        <Row>
          <Col className="mt-5 d-flex gap-3 justify-content-center">
            <Button className="bo-button" disabled={!uploadedFile} onClick={handleUpdate}>
              Update
            </Button>
            <Button className="bo-button" onClick={close}>
              Close
            </Button>
          </Col>
        </Row>
      </Spinner>
    </ReactModal>
  );
}

export default RewardUploadFileModal;
